<template lang="html">
  <v-container class="pa-0">
    <v-layout column>
        <v-card>
          <v-toolbar :extended="isMobile" :dense="!isMobile" flat>
            <template :slot="isMobile ? 'extension' : 'default'">
              <v-toolbar-items>
                <v-tabs v-model="tab"
                        :left="!isMobile"
                        :centered="isMobile"
                        grow show-arrows
                        color="#f5f5f5"
                        slider-color="primary">
                  <v-tab key="TxnHistory">
                    <v-layout column class="align-center">
                      <v-icon>receipt</v-icon>
                      Transaction History
                    </v-layout>
                  </v-tab>
                  <v-tab key="LoadHistory">
                    <v-layout column class="align-center">
                      <v-icon>local_shipping</v-icon>
                      Load History
                    </v-layout>
                  </v-tab>
                </v-tabs>
              </v-toolbar-items>
            </template>
          </v-toolbar>

          <v-tabs-items v-model="tab">
            <v-tab-item key="TxnHistory"
                        :transition="false"
                        :reverse-transition="false">
              <v-load-conversation :txn-id="transaction.id" class="mt-1" max-height="300">

                <template slot="conversationBanner">
                  <v-alert
                    v-if="transaction.customer.companyId"
                    :value="true"
                    color="primary"
                    icon="info"
                    outline>
                    A private conversation between the offices of {{ transaction.customer.companyName }}
                    and {{ transaction.vendor.companyName }}.
                  </v-alert>
                  <v-alert
                    v-else
                    :value="true"
                    color="primary"
                    icon="info"
                    outline>
                    {{ transaction.customer.companyName }} does not have an {{ $t('site-title.brief') }} account. This is
                    effectively a place for you to keep notes about this transaction.
                  </v-alert>
                </template>
              </v-load-conversation>
            </v-tab-item>
            <v-tab-item key="LoadHistory"
                        :transition="false"
                        :reverse-transition="false">
              <v-load-conversation :load-id="transaction.loadId" class="mt-1" max-height="300">
                <template slot="conversationBanner">
                  <div class="pa-4">
                    A fairly broad conversation between all the shipper employees, receiver
                    employees, the driver, and the offices of {{ transaction.customer.companyName }}
                    and {{ transaction.vendor.companyName }}.
                  </div>
                </template>
              </v-load-conversation>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';

import companyNamesMixin from '@/mixins/companyNames';
import loadGroupMixin from '@/mixins/loadGroupMixin';
import planningLoadGroupsMixin from '@/mixins/planningLoadGroupsMixin';

import VLoadConversation from '../LoadConversation';

export default {
  name: 'VLoadTransactionHistories',
  mixins: [
    companyNamesMixin,
    loadGroupMixin,
    planningLoadGroupsMixin,
  ],
  props: {
    company: {
      type: Object,
      required: true,
    },
    transaction: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    tab: null,

  }),
  components: {
    VLoadConversation,
  },
  watch: {
  },
  computed: {
    _() {
      return _;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
  },
  created() {
    this.tab = 0;
  },
  destroyed() {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/InfoWidgets/LoadTransactionHistories.vue